import EntityForm from "./EntityForm";

export default EntityForm;
